import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { LanguageData } from '../../../types/language-data';

export abstract class PackageGeneralFormBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getLanguages(): LanguageData[];
}
